import Banner from "../components/Banner";
import "../styles/HomePageStyling.css";
import CourseSlider from "../components/CourseSlider";
import {useEffect, useState} from "react";
import Introduction from "../components/Introduction";
import LoadingScreen from "../components/LoadingScreen";


function HomePage() {

    const [courses, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCourses().then(r => console.log("courses fetched"));
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/courses`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch data. Status: ${response.status}`);
            }

            const data = await response.json();
            console.log(data);
            setCourse(data);

        } catch (error) {
            console.error("Error fetching question groups:", error.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <LoadingScreen />;
    }

    return (
        <div>
            <Banner/>
            <Introduction id="our-facts"/>
            <CourseSlider id="courses" courses={courses}/>
        </div>
    );
}

export default HomePage;
